export default __webpack_public_path__ + "static/media/inventory_csv.9f78c71d.csv";